import { Extension } from "@tiptap/core"
import { Plugin, PluginKey } from "@tiptap/pm/state"

import type { EditorState } from "@tiptap/pm/state"

interface TriggerCharConfig {
	name: string
	char: string
	eventName: string
}

interface TriggerCheck {
	state: EditorState
	from: number
	to: number
	text: string
	char: string
}

// A trigger fires at the start of a text block or after whitespace only, so
// "foo;bar" and "name@example.com" stay plain text.
export function shouldFireTrigger({
	state,
	from,
	to,
	text,
	char,
}: TriggerCheck) {
	if (text !== char || from !== to) return false

	const $from = state.doc.resolve(from)
	if (!$from.parent.isTextblock) return false
	if ($from.parentOffset === 0) return true

	return /\s/.test(state.doc.textBetween(from - 1, from))
}

export function createTriggerCharExtension({
	name,
	char,
	eventName,
}: TriggerCharConfig) {
	return Extension.create({
		name,

		addProseMirrorPlugins() {
			return [
				new Plugin({
					key: new PluginKey(name),
					props: {
						handleTextInput: (view, from, to, text) => {
							if (
								!shouldFireTrigger({ state: view.state, from, to, text, char })
							) {
								return false
							}

							// Deferred so the char is in the doc before the popover reads the caret.
							requestAnimationFrame(() => {
								view.dom.dispatchEvent(
									new CustomEvent(eventName, { bubbles: true }),
								)
							})

							return false
						},
					},
				}),
			]
		},
	})
}
